import Vue from 'vue' // 引入Vue
import VueI18n from 'vue-i18n' // 引入国际化的插件包
import Cookies from 'js-cookie' // 引入cookie包
import elementEN from 'element-ui/lib/locale/lang/en' // 引入饿了么的英文包
import elementZH from 'element-ui/lib/locale/lang/zh-CN' // 引入饿了么的中文包
// 引入中文繁体包
import elementZHTW from 'element-ui/lib/locale/lang/zh-TW'
// 引入泰文包
import elementTH from 'element-ui/lib/locale/lang/th'
// 引入印尼文包
import elementID from 'element-ui/lib/locale/lang/id'
// 引入马来语
import elementMS from 'element-ui/lib/locale/lang/ms'
// 引入菲律宾
import elementTL from './el-tl'
// 引入越南语
import elementVI from 'element-ui/lib/locale/lang/vi'

import customZH from './zh' // 引入自定义中文包
import customEN from './en' // 引入自定义英文包 
import customZHTW from './zhtw' // 引入自定义中文繁体包
import customTH from './th' // 引入自定义泰文包
import customID from './id' // 引入自定义印尼文包
import customMS from './ms' // 引入自定义马来语包
import customTL from './tl' // 引入自定义菲律宾语包
import customVI from './vi' // 引入自定义越南语包

Vue.use(VueI18n) // 全局注册国际化包
const language = navigator.language || navigator.userLanguage;
let lang = ''
if (language === 'zh-CN') {
    lang = 'Chinese'
} else if (language === 'zh-TW') {
    lang = 'zh-TW'
} else if (language === 'en-US' || language == 'en') {
    lang = 'English'
} else if (language === 'th-TH' || language === 'th') {
    lang = 'Thai'
} else if (language === 'id-ID' || language === 'id') {
    lang = 'Indonesian'
} else if (language === 'ms-MY' || language === 'ms') {
    lang = 'Malay'
} else if (language === 'fil-PH' || language === 'fil') {
    lang = 'Filipino'
}else if(language === 'vi-VN' || language === 'vi'){
    lang = 'Vietnamese'
}else{
    lang = 'English'
}
// 创建国际化插件的实例
export default new VueI18n({
    
  // 指定语言类型
  locale: Cookies.get('language') || lang, // 从cookie中获取语言类型 获取不到就是中文
  messages: {
    English: {
      ...elementEN, // 将饿了么的英文语言包引入
      ...customEN
    },
    Chinese: {
      ...elementZH, // 将饿了么的中文语言包引入
      ...customZH
    },
    'zh-TW': {
      ...elementZHTW, // 将饿了么的中文繁体语言包引入
      ...customZHTW
    },
    Thai: {
      ...elementTH, // 将饿了么的泰文语言包引入
      ...customTH
    },
    Indonesian: {
      ...elementID, // 将饿了么的印尼文语言包引入
      ...customID
    },
    Malay: {
      ...elementMS, // 将饿了么的马来语语言包引入
      ...customMS
    },
    Filipino: {
      ...elementTL, // 将饿了么的菲律宾语语言包引入
      ...customTL
    },
    Vietnamese: {
      ...elementVI, // 将饿了么的越南语语言包引入
      ...customVI
    }
  }
})
